module.exports = __webpack_public_path__ + "static/news-placeholder-fba12f74a032a0dea96fc0049f6c9262.jpg";